import React from "react";
import Header from "../Header/Header";
import "./Home.scss";
import $ from "jquery";
import Footer from "../Footer/Footer";
import { Link as ScrollLink } from "react-scroll";
import { animateScroll as scroll } from "react-scroll";
import Arrow from "../../BackgroundImage/iconmonstr-arrow-66.svg";

function Home() {
  $(function () {
    $(".intro").addClass("go");

    $(".reload").click(function () {
      $(".intro")
        .removeClass("go")
        .delay(200)
        .queue(function (next) {
          $(".intro").addClass("go");
          next();
        });
    });
  });

  return (
    <main role="main">
      <section className="home">
        <Header />
        <div className="container">
          <svg className="intro">
            <text
              textAnchor="start"
              x="10"
              y="200"
              className="text text-stroke"
              clipPath="url(#text1)"
              style={{ fontFamily: "Aileron Thin" }}
            >
              ZEMEN TESHOME
            </text>
            <text
              textAnchor="start"
              x="40"
              y="250"
              className="text text-stroke-2"
              clipPath="url(#text2)"
            >
              FRONTEND DEVELOPER
            </text>
            <text
              textAnchor="start"
              x="10"
              y="300"
              className="text text-stroke-2"
              clipPath="url(#text3)"
            >
              BASED IN TORONTO
            </text>
            <text
              textAnchor="start"
              x="10"
              y="200"
              className="text text-stroke text-stroke-2"
              clipPath="url(#text1)"
            >
              ZEMEN TESHOME
            </text>
            <text
              textAnchor="start"
              x="40"
              y="250"
              className="text text-stroke text-stroke-2"
              clipPath="url(#text2)"
            >
              FRONTEND DEVELOPER
            </text>
            <text
              textAnchor="start"
              x="10"
              y="300"
              className="text text-stroke text-stroke-2"
              clipPath="url(#text3)"
            >
              BASED IN TORONTO
            </text>
            <defs>
              <clipPath id="text1">
                <text textAnchor="start" x="10" y="200" className="text">
                  ZEMEN TESHOME
                </text>
              </clipPath>
              <clipPath id="text2">
                <text textAnchor="start" x="40" y="250" className="text">
                  FRONTEND DEVELOPER
                </text>
              </clipPath>
              <clipPath id="text3">
                <text textAnchor="start" x="10" y="300" className="text">
                  BASED IN TORONTO
                </text>
              </clipPath>
            </defs>
          </svg>
        </div>
        <ScrollLink
          className="home__scroll"
          to="footer"
          smooth={true}
          duration={1000}
        >
          <img
            className="home__arrow"
            src={
              process.env.PUBLIC_URL + "/assets/images/iconmonstr-arrow-65.svg"
            }
            alt="arrow"
          />
        </ScrollLink>
        <div className="home__background-container">
          <div className="home__background-image"></div>
        </div>
        <img
          className="home__arrow-top"
          src={Arrow}
          alt="arrow"
          onClick={() => {
            scroll.scrollToTop();
          }}
        />
        <Footer />
      </section>
    </main>
  );
}

export default Home;
